const DISMISS_KEY = "notification-push-prompt-dismissed:v1";
const DISMISS_TTL_MS = 7 * 24 * 60 * 60 * 1000;

type DismissPayload = {
  dismissedAt: number;
};

export function isPushPromptDismissed(): boolean {
  try {
    const raw = localStorage.getItem(DISMISS_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw) as DismissPayload;
    if (typeof parsed.dismissedAt !== "number") return false;
    return Date.now() - parsed.dismissedAt < DISMISS_TTL_MS;
  } catch {
    return false;
  }
}

export function dismissPushPrompt(): void {
  try {
    const payload: DismissPayload = {dismissedAt: Date.now()};
    localStorage.setItem(DISMISS_KEY, JSON.stringify(payload));
  } catch {
    // private browsing / quota
  }
}
